import { __module as e } from "./index.es400.js";
import { _ as v } from "./index.es384.js";
import { s as x } from "./index.es401.js";
e.exports;
(function(r, f) {
  var a = v, i = x, o = f && !f.nodeType && f, s = o && !0 && r && !r.nodeType && r, p = s && s.exports === o, t = p ? a.Buffer : void 0, u = t ? t.isBuffer : void 0, n = u || i;
  r.exports = n;
})(e, e.exports);
var _ = e.exports;
export {
  _ as i
};
//# sourceMappingURL=index.es266.js.map
